import { NavigateFn } from '@tanstack/react-router';
import {
	AlertDialogCancel,
	AlertDialogDescription,
	AlertDialogFooter,
	AlertDialogHeader,
	AlertDialogTitle,
	Button,
} from '@uturn/ui-kit';
import { useTranslation } from 'react-i18next';

export const ShipmentPublishedModal = ({
	shipmentNumber,
	navigate,
	copyShipment,
}: {
	shipmentNumber: string;
	navigate: NavigateFn;
	copyShipment: () => void;
}) => {
	const { t } = useTranslation();

	return (
		<>
			<AlertDialogHeader>
				<AlertDialogTitle>
					{t(
						'pages.shipment.modal.published.title',
						'Shipment {{shipmentNumber}} published',
						{ shipmentNumber },
					)}
				</AlertDialogTitle>
				<AlertDialogDescription>
					{t(
						'pages.shipment.modal.published.body',
						'You have successfully published shipment {{shipmentNumber}}.What would you like to do next?',
						{ shipmentNumber },
					)}
				</AlertDialogDescription>
			</AlertDialogHeader>
			<AlertDialogFooter>
				<div className="flex gap-2">
					<Button
						variant="outline"
						onClick={() => {
							navigate({
								to: '/shipments/$shipmentNumber',
								params: { shipmentNumber: Number(shipmentNumber) },
							});
						}}
					>
						{t(
							'pages.addshipment.modal.actions.check-details',
							'Shipment details',
						)}
					</Button>
					<Button
						variant="outline"
						onClick={() => {
							navigate({ to: '/shipments' });
						}}
					>
						{t(
							'pages.addshipment.modal.actions.back-to-overview',
							'Shipments overview',
						)}
					</Button>
				</div>
				<AlertDialogCancel asChild>
					<Button variant="outline" onClick={copyShipment}>
						{t('pages.addshipment.modal.actions.copy', 'Copy')}
					</Button>
				</AlertDialogCancel>
				<Button
					onClick={() => {
						navigate({ to: '/shipments/add' });
					}}
				>
					{t('pages.addshipment.modal.actions.new', 'Create new')}
				</Button>
			</AlertDialogFooter>
		</>
	);
};
